import { render, staticRenderFns } from "./score-return-link.vue?vue&type=template&id=25a3944b&scoped=true&"
import script from "./score-return-link.vue?vue&type=script&lang=js&"
export * from "./score-return-link.vue?vue&type=script&lang=js&"
import style0 from "./score-return-link.vue?vue&type=style&index=0&id=25a3944b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3944b",
  null
  
)

export default component.exports